import { createField } from './enemy-field';
import { DAIS_R } from './codex-scene';
/* ============================================================
   群體壓力（開發模式）
   ============================================================

   從 `codex-model.ts` 拆出來的（B3，行數）。它與展示台上那一隻是
   **互斥**的兩種畫面：群體壓力開著的時候展品與刻度標尺都收起來。 */

var field: any = null;

/** 0–420 隻同型排在台子外圍。用的是**戰場那一條實例化路徑**
    （`createField`），所以這裡量到的 draw call 就是戰場上的那個數字。 */
var swarmCache = {};
/** 群體壓力用的型別代理：**只多一個 `cap`**。
    `Field.push()` 用 `T.cap || 220` 決定每型的容量，而造型表沒有 `cap`
    （那是 `data/enemy-stats.ts` 的欄位，深層 12 隻連那張表都還沒有）——
    不補的話滑桿拉到 420 而畫面上只有 220 隻，**讀數會說謊**。
    快取起來是因為 `ensure()` 認的是 `T.id`，每幀換物件會白白重建。 */
function swarmType(T) {
  var c = swarmCache[T.id];
  if (c) return c;
  c = Object.create(T); c.cap = 440;
  swarmCache[T.id] = c;
  return c;
}

export function setCodexSwarm(T, n, t) {
  if (!field) field = createField(440);
  field.begin();
  if (T && n > 0) {
    T = swarmType(T);
    var o: any = { x: 0, z: 0, yaw: 0, t: t, ph: 0, mv: 1, tel: 0, atk: 0, hit: 0, q: {}, sc: T.bodyK,
      ry: 0, rp: 0, rr: 0, rz: 0, crown: false, crownH: T.h };
    for (var k in T.q0) o.q[k] = T.q0[k];
    for (var i = 0; i < n; i++) {
      /* 黃金角螺線：任何 n 都是均勻的，不用為每個數量調參數。 */
      var a = i * 2.39996, r = DAIS_R + 1.2 + Math.sqrt(i) * 0.62;
      o.x = Math.cos(a) * r; o.z = Math.sin(a) * r;
      o.yaw = -a + Math.PI;
      o.ph = (t * T.gait * 0.16 + i * 0.137) % 1;
      if (T.pose) { o.ry = 0; o.rp = 0; o.rr = 0; o.rz = 0; T.pose(o); }
      field.push(T, o);
    }
  }
  field.end();
  return field.stats();
}
export function clearCodexSwarm() { if (field) { field.clear(); field = null; } }

